import environmentConfigCreateComponent from './environment_config.create.component';

let environmentConfigCreateModule = angular.module('environmentConfigCreate', [])

    .component('environmentConfigCreate', environmentConfigCreateComponent)

    .name;

export default environmentConfigCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/create/index.js